@if (station()) {
  <div class="is-flex is-column is-fullwidth">
    <div class="station-infos is-flex is-column gap-8">
      <div class="is-flex is-justify-space-between">
        <app-text class="text-22 is-family-semiBold">{{ station().city }}</app-text>
        <div class="is-flex gap-24 is-flex-shrink-0">
          <div class="is-flex gap-8">
            @if (loggedIn()) {
              <div class="action-icon is-relative is-flex is-align-center radius-6 bg-grey-hover-10 text-yellow is-cursor-pointer"
                (click)="toggleFavorite()"
                [class.is-loading]="loading()"
                [class.disabled]="!isFavorite() && favoriteStations().length >= 5"
                [attr.title]="!isFavorite() && favoriteStations().length >= 5 ? ('station.__FAVORITES_NO_MORE' | AsyncLang | async) : ''">
                <app-icon [name]="isFavorite() ? 'rate-full' : 'rate'" class="text-18" />
              </div>
            }
            <div class="action-icon is-flex is-align-center radius-6 bg-grey-hover-10" (click)="toggleSharePanel()">
              <app-icon name="share-16" class="text-16 text-blue is-cursor-pointer" />
            </div>
          </div>
          <div class="action-icon is-flex is-align-center radius-6 bg-grey-hover-10">
            <app-icon (click)="close()" name="close" class="text-18 is-cursor-pointer" />
          </div>
        </div>
      </div>
        <div class="is-flex is-justify-space-between">
          <div class="is-flex is-column gap-4">
            <app-text class="text-grey-70 is-family-medium">Altitude: {{ station().altitude }}m</app-text>
          </div>
          <div class="is-flex is-column is-justify-space-between is-align-self-start is-flex-shrink-0">
            <app-text class="text-grey-70 is-family-medium">{{ lastUpdate() }}</app-text>
          </div>
        </div>
    </div>

    <div [@openClose]="shareOpenState()">
      <div class="separator"></div>

      <div class="share is-flex is-column gap-8">
        <div class="is-flex is-justify-space-between">
          <app-text class="text-14 is-family-semiBold" [text]="'app.__MAP_LINK_TO_SHARE' | AsyncLang | async"/>
          <div class="text-14 text-blue is-family-semiBold is-cursor-pointer"
            (click)="copyLink()">
            @if (linkCopied()) {
              <app-text [text]="'app.__MAP_COPY_LINK_CONFIRMED' | AsyncLang | async" />
            }
            @else {
              <app-text [text]="'app.__MAP_COPY_LINK' | AsyncLang | async" />
            }
          </div>
        </div>
        <input class="text-grey-70" type="text" disabled [value]="shareLink()">
      </div>
    </div>

    <div class="separator"></div>

    @if (hasOutdoor()) {
      <app-temperature-card/>

      <div class="separator"></div>

      <app-humidity-card/>

      <div class="separator"></div>
    }

    <app-pressure-card/>

    <div class="separator"></div>

    @if (hasWind()) {
      <app-wind-card/>

      <div class="separator"></div>
    }

    @if (hasRain()) {
      <app-rain-card/>

      <div class="separator"></div>
    }

    @if (hasOutdoor()) {
      <app-forecast/>

      <div class="separator"></div>
    }

  </div>
}